import { ScoresObject, ScoreResult } from '../types';

export const scoreResult2ScoresObject = (scoreResult: ScoreResult[]) => {
  return scoreResult.reduce((acc, { question, score }) => {
    acc[question as keyof ScoresObject] = score;
    return acc;
  }, {} as ScoresObject);
};
